import React, { useEffect, useRef } from "react";
import Datepicker from "helpers/Datepicker";
import moment from "moment/moment";

export default function InlineDatePicker({
  date,
  setDate,
}: {
  date: string;
  setDate: (date: string) => void;
}) {
  const datePickerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const datepicker = new Datepicker(datePickerRef.current, {
      pickLevel: 1,
      todayBtn: true,
      todayBtnMode: 1,
      clearBtn: false,
      defaultViewDate: new Date(date),
    });

    datepicker.element.addEventListener("changeDate", (event) =>
      setDate(moment(event.detail.date).format()),
    );

    return () => datepicker.destroy();
  }, [date, datePickerRef]);

  return <div className="tixxt__inline_date-picker" ref={datePickerRef} />;
}
